import { del, get, patch, post } from "@/lib/api-client-v2";
import type {
  WorkItem,
  WorkItemCreatePayload,
  WorkItemHistoryEntry,
  WorkItemMapPoint,
  WorkItemMeta,
  WorkItemStatusChangePayload,
  WorkItemsListParams,
  WorkItemsMapParams,
  WorkItemUpdatePayload,
} from "@/types/work-items";

export const workItemsApi = {
  getMeta: () => get<WorkItemMeta>("/work-items/meta"),

  list: (params?: WorkItemsListParams) => {
    const query: Record<string, string | number | boolean> = {};
    if (params?.status) query.status = params.status;
    if (params?.assignedToUserId) query.assignedToUserId = params.assignedToUserId;
    if (params?.objectId != null) query.objectId = params.objectId;
    if (params?.limit != null) query.limit = params.limit;
    return get<WorkItem[]>("/work-items", query);
  },

  /**
   * Точки для слоя на главной карте. В Network (Fetch/XHR) ищите имя `map` в пути
   * полного URL: **`/api/v1/work-items/map?bounds=...&limit=...`** — не путать с `kls`, `map-cluster`, MVT.
   */
  listMapPoints: (params?: WorkItemsMapParams) => {
    const query: Record<string, string | number> = {};
    if (params?.bounds) query.bounds = params.bounds;
    if (params?.status) query.status = params.status;
    if (params?.limit != null) query.limit = params.limit;
    return get<WorkItemMapPoint[]>("/work-items/map", query);
  },

  get: (id: number) => get<WorkItem>(`/work-items/${id}`),

  getHistory: (id: number) => get<WorkItemHistoryEntry[]>(`/work-items/${id}/history`),

  create: (payload: WorkItemCreatePayload) => post<WorkItem>("/work-items", payload),

  update: (id: number, payload: WorkItemUpdatePayload) =>
    patch<WorkItem>(`/work-items/${id}`, payload),

  changeStatus: (id: number, payload: WorkItemStatusChangePayload) =>
    post<WorkItem>(`/work-items/${id}/status`, payload),

  remove: (id: number) => del<void>(`/work-items/${id}`),

  eta: (id: number, from: { lon: number; lat: number }) =>
    post<{
      workItemId: number;
      fromLon: number;
      fromLat: number;
      toLon: number;
      toLat: number;
      anchorSource: string;
      airDistanceM: number;
      roadDistanceM: number | null;
      roadDurationS: number | null;
      roadOk: boolean;
      roadError?: string | null;
    }>(`/work-items/${id}/eta`, from),
};

